import * as _ from 'lodash';
import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';

import * as NotificationsActions from '../../../../main/actions/notifications-actions';

module.exports = {
  templateUrl: 'profile/components/tabs/notification-management/notification-management.html',
  controller: class NotificationManagement {

    static $inject = [
      '$ngRedux',
      'ProfileService',
      'PatientAppContextService',
    ];

    constructor($ngRedux, ProfileService, PatientAppContextService) {
      this.$ngRedux = $ngRedux;
      this.ProfileService = ProfileService;
      this.PatientAppContextService = PatientAppContextService;
    }

    $onInit() {
      this.notifications = [];
      this.notificationsUpdated = [];
      this.context = this.PatientAppContextService.context;
      this.authenticated = this.context.authenticatedPatient;
      this.patients = _.keyBy([this.authenticated].concat(this.authenticated.children), 'id');
      this.accounts = _.keyBy((_.uniqBy(((() => {
        const result = [];
        _.each(this.patients, (patient) => {
          if (patient) {
            result.push(patient.subscription.account);
          }
        });
        return result;
      })()), 'id')), 'id');

      this.getNotifications();
    }

    getNotifications() {
      this.notifications = _.sortBy(this.setNotifications(_.cloneDeep(this.context.notifications)), 'account.lastName');
      this.notificationsUpdated = _.cloneDeep(this.notifications);
      if (this.notifications[0]) {
        this.selectedNotificationId = this.notifications[0].id.toString();
      }

      return this.setCurrent();
    }

    setCurrent() {
      this.current = _.find(this.notificationsUpdated, {
        id: parseInt(this.selectedNotificationId),
      });
    }

    setNotifications(data) {
      const notifications = [];
      let id = 1;

      _.each(data, (notification) => {
        const alreadyThereNotification = _.find(notifications, {
          accountId: notification.accountId,
          kind: notification.kind,
          date: notification.date,
        });

        if (alreadyThereNotification != null) {
          return alreadyThereNotification.patients.push(this.patients[notification.patientId]);
        }
        notification.patients = [this.patients[notification.patientId]];
        notification.account = this.accounts[notification.accountId];
        notification.id = id++;
        return notifications.push(_.omit(notification, ['patientId']));
      });

      return notifications;
    }

    isSubmitDisabled() {
      return this.isSubmitting || !_.some(this.changedNotifications()) || _.some(this.notificationsUpdated, notification => (notification.kind === 'specific_date') && (notification.date === null));
    }

    submit($event) {
      $event.preventDefault();

      this.isSubmitting = true;
      this.ProfileService.putNotification({
        patient_id: parseInt(this.authenticated.id),
        group_id: this.context.group.id,
        notifications: this.cleanNotifications(),
      }, () => {
        this.ProfileService.getNotification(this.authenticated, this.context.group.id, (response) => {
          this.$ngRedux.dispatch(NotificationsActions.setNotifications(response.data));

          this.isSubmitting = false;
          this.notifications = _.cloneDeep(this.notificationsUpdated);
          this.$ngRedux.dispatch(new ShowFlash({ name: 'update', expiresAfter: 2500, additionalInfos: { title: 'update.notification.update_success' } }));
        });
      });
    }

    cancel($event) {
      $event.preventDefault();

      this.notificationsUpdated = _.cloneDeep(this.notifications);
      this.setCurrent();
    }

    cleanNotifications() {
      return _.map(_.cloneDeep(this.changedNotifications()), (notification) => {
        if (notification.kind !== 'specific_date') {
          notification.date = null;
        }

        notification.account_id = notification.accountId;
        return _.omit(notification, ['account', 'accountId', 'patients']);
      });
    }

    changedNotifications() {
      return _.reject(this.notificationsUpdated, (notification) => {
        const originalNotification = _.find(this.notifications, {
          id: notification.id,
        });
        return _.isEqual(angular.toJson(notification), angular.toJson(originalNotification));
      },
      );
    }
  },
};



// WEBPACK FOOTER //
// ./profile/components/tabs/notification-management/notification-management.js